import { Grid, Typography } from '@mui/material';
import { getDashboardChartGridProps } from 'charts/catalog/analyticsDashboardLayout';
import { CatalogChartRenderer } from 'charts/components/CatalogChartRenderer';
import { ChartResultStatus } from 'charts/catalog/types';
import { type ChartId } from 'charts/catalog/chartCatalog';
import React, { ReactElement } from 'react';
import { MemoChartReloader } from '../../chartReloader';
import { SectionChartCard } from '../SectionChartCard';
import { sectionLabelSx, sectionSx } from '../styles';
import type { AnalyticsChartGroupPresentationalProps } from '../types';

export function AnalyticsChartGroupPresentational({
  sectionLabel,
  charts,
  runtimeById,
  isChartId,
  resolveChartTitle,
  resolveChartSubtitle,
}: AnalyticsChartGroupPresentationalProps): ReactElement | null {
  if (charts.length === 0) {
    return null;
  }

  return (
    <>
      <Typography component="p" sx={sectionLabelSx}>
        {sectionLabel}
      </Typography>
      <Grid container spacing={3} sx={sectionSx}>
        {charts.map((chart) => {
          if (!isChartId(chart.id)) {
            return null;
          }

          const chartRuntime = runtimeById[chart.id];
          if (!chartRuntime) {
            return null;
          }

          const subtitle = resolveChartSubtitle(chart.id);
          const gridProps = getDashboardChartGridProps(chart.id);

          return (
            <MemoChartReloader key={chart.id} context={chartRuntime}>
              <Grid item {...gridProps}>
                <SectionChartCard
                  chartId={chart.id}
                  loading={chart.status === ChartResultStatus.loading}
                  title={resolveChartTitle(chartRuntime.titleId)}
                  subtitle={subtitle}
                >
                  <CatalogChartRenderer chartId={chart.id} />
                </SectionChartCard>
              </Grid>
            </MemoChartReloader>
          );
        })}
      </Grid>
    </>
  );
}

export const MemoAnalyticsChartGroupPresentational = React.memo(
  AnalyticsChartGroupPresentational
);
